import { useState, useEffect, useMemo } from 'react';
import useAxios from 'axios-hooks';
import { route } from './CopyAndFunctions';

const useDataState = (seriesIdFromParams) => {
    const [isProcessing, setIsProcessing] = useState(true);
    const [eligibleData, setEligibleData] = useState([]);
    const hasEligibleData = eligibleData.length > 0;
    const isNew = !seriesIdFromParams;

    const [{ data: allContent, loading: allContentLoading }] = useAxios(`${route}/eligible-content`);
    const [{ data: seriesData, loading: seriesLoading }] = useAxios({ 
            url: `${route}/${seriesIdFromParams}`, method: "get" }, { manual: isNew });
    const [{ data }, submitForm] = useAxios({ url: `${route}/upsert`, method: "post" }, { manual: true });

    useEffect(() => {
        if (allContentLoading || seriesLoading) return;
    
        setEligibleData(allContent);
        setIsProcessing(false);
    }, [allContent, allContentLoading, seriesLoading]);

    const isReady = useMemo(() => {
        return hasEligibleData && !isProcessing;
    }, [hasEligibleData, isProcessing]);

    return {
        setIsProcessing,
        eligibleData,
        setEligibleData,
        isReady,
        submitForm,
        seriesData,
    };
};

export default useDataState;
